import { AssetTypeSelect, AssetTypeSelectProps } from './AssetTypeSelect';
import { Heading, Wrapper } from './SelectSystemAsset.styles';
import { SystemTypeSelect, SystemTypeSelectProps } from './SystemTypeSelect';

import { LayersIcon } from './LayersIcon';
import React from 'react';
import { useGlobalization } from '../../../../../../i18n/useGlobalization';

type SelectSystemAssetProps = SystemTypeSelectProps & AssetTypeSelectProps;

export const SelectSystemAsset = ({
	assetType,
	systemType,
	onSystemTypeChange,
	onAssetTypeChange,
	systemTypes,
	assetTypes,
	systemSchema,
	assetSchema,
	loadSystemSchema,
	loadAssetSchema,
}: SelectSystemAssetProps): JSX.Element => {
	const { t } = useGlobalization();

	return (
		<Wrapper>
			<Heading>
				{t('To see a list of assets, select a data type and layer')}
			</Heading>
			<LayersIcon />
			<div>
				<SystemTypeSelect
					systemType={systemType}
					onSystemTypeChange={onSystemTypeChange}
					systemTypes={systemTypes}
					systemSchema={systemSchema}
					loadSystemSchema={loadSystemSchema}
					dataCy="system-type-select"
				/>
				<AssetTypeSelect
					systemType={systemType}
					assetType={assetType}
					onAssetTypeChange={onAssetTypeChange}
					assetTypes={assetTypes}
					assetSchema={assetSchema}
					loadAssetSchema={loadAssetSchema}
					dataCy="asset-type-select"
				/>
			</div>
		</Wrapper>
	);
};
